<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-10 16:55:39
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-15 21:59:04
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/map-dttj.vue
 * @Description: 地图统计
-->
<template>
  <div class="dttj" v-loading="loading.dttj">
    <template v-if="!loading.dttj">
      <div class="item" v-for="(item, index) in dttj" :key="index">
        <i class="arrow" />
        <div class="name">{{ item.name + "(" + item.unit + ")" }}</div>
        <div class="value" v-if="item.value === 0">{{ item.value }}</div>
        <ICountUp class="value" v-else :endVal="Number(item.value)" />
        <i class="divider" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('company-profile', ['dttj', 'loading'])
  },
  methods: {
    ...mapActions('company-profile', ['getDTTJ'])
  },
  created () {
    this.getDTTJ()
  }
}
</script>

<style lang="scss">
.dttj {
  width: 189px;
  height: 432px;
  .item {
    position: relative;
    height: 86px;
    margin-bottom: 30px;
    &:last-of-type {
      margin-bottom: 0;
    }
    .arrow {
      position: absolute;
      left: 0;
      top: 4px;
      // width: 14px;
      // height: 26px;
      // background: #10f5b1;
      width: 0;
      height: 0;
      border-top: 13px solid transparent;
      border-right: 14px solid transparent;
      border-bottom: 13px solid transparent;
      border-left: 14px solid #10f5b1;
    }
    .name {
      position: absolute;
      right: 0;
      width: 167px;
      height: 34px;
      line-height: 34px;
      background: #376766;
      padding-left: 24px;
      padding-left: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .value {
      position: absolute;
      top: 44px;
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 28px;
      font-family: Bahnschrift;
      font-weight: 600;
      color: #ffffff;
    }
    .divider {
      position: absolute;
      top: 86px;
      left: 0;
      width: 100%;
      height: 2px;
      background-position: center;
      background-image: url("/public/image/company-profile/icon/下划线@2x.png");
    }
  }
}
</style>
